import FadeIn from 'react-fade-in';

export const About = () => {


    return (
        <FadeIn>
            <br />
            <div className={"pagecontainer"} >
                <h1>About</h1>
                This project was made for the Visualization 2 course of the TU Wien in SS2021 by Lukas Brunner and Jonas Prohaska.
                <br /><a href="https://github.com/bruluk5w/browler_engine/tree/master" target="_blank"  rel="noreferrer">Visit the project on Github</a>
                <h1>References</h1>
                [1] J. G. Magnus and S. Bruckner, “Interactive Dynamic Volume Illumination with Refraction and Caustics,” IEEE Trans. Vis. Comput. Graph., vol. 24, no. 1, pp. 984–993, 2018, doi: 10.1109/TVCG.2017.2744438.
                <br/><a href="https://ieeexplore.ieee.org/document/8017622" target="_blank"  rel="noreferrer">Link to original Paper</a>

                <br/><br/><br/>© Lukas Brunner & Jonas Prohaska
            </div>
        </FadeIn>
    )
}
